import React from 'react';
import {} from 'react-native';
import Reanimated from 'react-native-reanimated';
import { IRubberBandPresentationProps } from './';

export const RubberBandPresentation: React.FC<IRubberBandPresentationProps> = (
  props,
) => {
  return (
    <Reanimated.View style={props.containerStyle}>
      {props.children}
    </Reanimated.View>
  );
};
